import type { ReactElement } from 'react';
import { ConnectedApps } from './ConnectedApps';
import { SettingsLayout } from '../settings/SettingsLayout';

/** What a person has let into their meetings, and the tokens for clients that cannot open a browser. */
export function Connected(): ReactElement {
  return (
    <SettingsLayout
      title="Connected apps"
      sub="MCP · OAuth — what reads your meetings, and how you take it back"
    >
      <ConnectedApps />
    </SettingsLayout>
  );
}
